import React from 'react';

const Loader = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4'
  };

  return (
    <div className={`flex justify-center items-center py-6 ${className}`}>
      <div
        className={`${sizeClasses[size] || sizeClasses.md} border-green-600/20 border-t-green-600 rounded-full animate-spin`}
      />
    </div>
  );
};

export default Loader;
